import { Box, Skeleton } from "@mui/material";
import { useCustomStyle } from "./UserRoleListCard.style";

const SkeletonCard = () => {
  const classes = useCustomStyle();
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <Box key={index} className={`${classes.userListRowWrapper} skeltoncard`}>
          <Box className='userListRowItem'>
            <Skeleton variant='rectangular' width={42} height={42} sx={{ marginRight: "20px" }} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant='text' height={24} width={120} />
              <Skeleton variant='text' height={18} width={200} />
            </Box>
            <Box sx={{ display: "flex" }}>
              <Box className='assignee' sx={{ textAlign: "right", flex: 1 }}>
                <Skeleton variant='text' width={80} height={24} />
                <Skeleton variant='text' width={40} height={28} />
              </Box>

              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Skeleton variant='circular' width={24} height={24} />
                <Skeleton variant='circular' width={24} height={24} />
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default SkeletonCard;
